import size from '@/assets/theme/size';
import { BasicComponentProps } from '@/typings/generic';
import styled from '@emotion/styled';

const { mobile } = size;

const MenuItemText = styled.span<BasicComponentProps>(
	({ theme, $breakpoints }) => {
		return {
			lineHeight: '27.32px',
			textTransform: 'uppercase',
			fontFamily: theme.font.families.secondary.demiBold,
			fontWeight: 600,
			letterSpacing: '1.6px',
			fontSize: 8,
			WebkitFontSmoothing: 'antialiased',
			[theme.media.desktop.laptop]: {
				lineHeight: '72px',
				fontSize: 11,
			},
			[theme.media.desktop.sm]: {
				lineHeight: '15px',
				fontSize: 11,
			},
			[theme.media.mobile]:
				$breakpoints && $breakpoints[mobile]
					? $breakpoints[mobile]
					: {},
		};
	},
);

export default MenuItemText;
